export enum DevicePlatform {
  Web = 'Web',
  Ios = 'iOS',
  Android = 'Android',
  Huawei = 'Huawei',
  Desktop = 'Desktop',
  Other = 'Other',
}

export enum DeviceStatus {
  Pending = 'PENDING',
  Trusted = 'TRUSTED',
  Blocked = 'BLOCKED',
  Unlocked = 'UNLOCKED',
  Deleted = 'DELETED',
}

export interface IDevice {
  deviceId: string;
  platform: DevicePlatform;
  device: string;
  osName?: string;
  osVersion?: string;
  appVersion: string;
  status?: DeviceStatus;
}

export interface IDeviceSession {
  lastActivityTs?: number;
  ipAddress?: string;
  location?: string;
  isOnline?: boolean;
}
